export default __webpack_public_path__ + "static/media/skill_aws.36085b2c.png";